export const AppStyles = {
  container:
    'flex flex-col items-center justify-start min-h-screen text-black text-base font-body',
}
